import React, {forwardRef, useRef} from "react";

import {useCombinedRefs} from "@pg-mono/hooks";

import {TextInputBase} from "../../atoms/TextInputBase";
import {FieldWrapper} from "../../atoms/wrapper/FieldWrapper";
import {IInputWrapperProps, InputWrapper} from "../../atoms/wrapper/InputWrapper";
import {getErrorMessage} from "../../utils/get_error_message";
import {ITextareaCoreProps, TextareaCore} from "./TextareaCore";

export type ITextAreaProps = IInputWrapperProps &
    ITextareaCoreProps & {
        message?: string;
        error?: string[] | string | undefined;
        inputWrapperClassName?: string;
        inputWrapperInnerClassName?: string;
        inputContentSlot?: React.ReactNode;
        inputClassName?: string;
    };

export const Textarea = forwardRef<HTMLTextAreaElement, ITextAreaProps>((props, forwardedRef) => {
    const {
        fieldState,
        detail,
        className,
        message,
        rows = 4,
        inputContentSlot,
        inputWrapperClassName,
        inputWrapperInnerClassName,
        inputClassName,
        ...restProps
    } = props;
    const localRef = useRef<HTMLTextAreaElement | null>(null);
    const inputRef = useCombinedRefs<HTMLTextAreaElement>(localRef, forwardedRef);

    const events = {
        onClick: (event: React.MouseEvent) => {
            event.stopPropagation();

            if (localRef.current) {
                localRef.current.focus();
            }
        }
    };

    return (
        <FieldWrapper fieldState={fieldState} message={getErrorMessage(props.error) || message}>
            <TextInputBase onClick={events.onClick} fieldState={fieldState ?? "default"} className={className}>
                <InputWrapper fieldState={fieldState} detail={detail} className={inputWrapperClassName} inputWrapClassName={inputWrapperInnerClassName}>
                    <TextareaCore rows={rows} {...restProps} ref={inputRef} className={inputClassName} />
                    {inputContentSlot && inputContentSlot}
                </InputWrapper>
            </TextInputBase>
        </FieldWrapper>
    );
});
